import { useState } from "react";
import { FaUserMinus } from "react-icons/fa";
import { SoftButton } from "../../UI/DesignStandards";

const RemoveMemberButton = ({ member, onRemove }) => {
  const [isConfirming, setIsConfirming] = useState(false);

  const handleRemoveClick = () => {
    setIsConfirming(true);
  };

  const handleCancel = () => {
    setIsConfirming(false);
  };

  const handleConfirm = () => {
    onRemove(member);
    setIsConfirming(false);
  };

  return (
    <div className="flex items-center">
      {isConfirming ? (
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-sm text-red-700 font-medium">Remove?</span>
          <SoftButton color="cream" size="xs" onClick={handleCancel}>
            No
          </SoftButton>
          <SoftButton color="red" size="xs" onClick={handleConfirm}>
            Yes
          </SoftButton>
        </div>
      ) : (
        <SoftButton
          color="red"
          size="sm"
          onClick={handleRemoveClick}
          iconLeft={<FaUserMinus className="h-3.5 w-3.5" />}
        >
          Remove
        </SoftButton>
      )}
    </div>
  );
};

export default RemoveMemberButton;
